module.exports = __webpack_public_path__ + "media/theme/zigzag-black-ecbd610c.png";